import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import {
  user_company_domain_list,
  user_company_details,
  create_company_request,
  update_company_registration,
  user_dash_list,
} from "../../user.api";

import BasicDetails from "./manage/form";
import View from "./manage/viewDetails";
import "./style.css";
import jwtDecode from "jwt-decode";

export default function NewCompanyRequest(props) {
  const [activeStep, setActiveStep] = useState(0);
  const [defaultkey, setdefaultkey] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [basicData, setBasicData] = useState({});
  const myRef = useRef(null);
  const [domainData, setDomain] = useState([]);
  const [addCount, setCount] = useState(1);

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const getDomainTypes = () => {
    setIsActive(true);
    user_company_domain_list().then((res) => {
      let domData = res?.data;
      getDetails(domData);
    });
  };
  const action = (id, data, key) => {
    myRef.current.scrollIntoView();
    if (id === 0) {
      let dom = [];
      domainData.forEach((item) => {
        if (item.checked)
          dom.push({ domain_name: item.domain_name, id: item.id });
      });

      setBasicData({ ...data, domain_types: dom });
      setActiveStep(1);
      //
    } else if (id === 2) {
      setdefaultkey(key);
      setActiveStep(0);

      // setBasicData({ ...data });
    } else if (id === 3) {
      // setBasicData({ ...data });
      handleSubmit();
    }
  };
  const handleSubmit = () => {
    setIsActive(true);

    let areatype = [];
    if (basicData.area_management) {
      basicData?.area_management?.forEach((item, index) => {
        if (item.location_id) {
          areatype[index] = item;
        }
      });
    }
    const form = new FormData();
    console.log(basicData.product_profiles);

    const appendIfValue = (key, value) => {
      if (value !== null && value !== undefined && value !== "" && value !== "null" && value !== "undefined") {
        form.append(key, value);
      }
    };

    appendIfValue("company_name", basicData.company_name);
    appendIfValue("phone_number", basicData.mobile_number);
    appendIfValue("company_type", "kerala");
    appendIfValue("person_name", basicData.person_name);
    appendIfValue("person_designation", basicData.person_designation);
    appendIfValue("address", basicData.address);
    appendIfValue("email", basicData.email);
    appendIfValue("alternate_email", basicData.alternate_email);
    appendIfValue("logo", basicData.logo);
    appendIfValue(
      "abstract_project_proposal",
      basicData.abstract_project_proposal
    );
    if (
      basicData.country_code &&
      basicData.country_code !== "" &&
      basicData.alternate_phone &&
      basicData.alternate_phone !== ""
    ) {
      appendIfValue("country_code", basicData.country_code);
    }
    appendIfValue("alternate_phone", basicData.alternate_phone);
    appendIfValue("site_link", basicData.site_link);
    appendIfValue("upload_proposal", basicData.upload_proposal);
    appendIfValue("registration_certificate", basicData.registration_certificate);
    appendIfValue("registration_certificate_name", basicData.registration_certificate_name);
    appendIfValue("capital_investment", basicData.capital_investment);
    appendIfValue("ex_man_power", basicData.ex_man_power);
    appendIfValue("cin_number", basicData?.cin_number ?? "--");
    appendIfValue("previous_fy_turnover", basicData.previous_fy_turnover);
    // form.append("product_profiles", basicData.product_profiles ?? null);
    appendIfValue("dir_employ_male", basicData.dir_employ_male);
    appendIfValue("dir_employ_female", basicData.dir_employ_female);
    appendIfValue("dir_employ_others", basicData.dir_employ_others);
    appendIfValue("dir_employ_sc_st", basicData.dir_employ_sc_st);
    appendIfValue("achievements", basicData.achievements);
    appendIfValue("fe_component", basicData.fe_component);
    if (basicData.certification === "Other") {
      if (basicData.otherCertification && String(basicData.otherCertification).trim() !== "") {
        appendIfValue("certification", basicData.otherCertification);
      }
    } else if (basicData.certification && String(basicData.certification).trim() !== "") {
      appendIfValue("certification", basicData.certification);
    }
    appendIfValue("any_other_flag", basicData.any_other_flag == true ? "1" : "0");
    appendIfValue(
      "any_other_domain",
      basicData.any_other_flag == true ? basicData.any_other_domain : ""
    );
    appendIfValue("file_name", basicData.file_name);
    if (basicData.id) appendIfValue("application_id", basicData.id);
    basicData.product_profiles.forEach((item, index) => {
      appendIfValue(
        `product_profiles[${index}][product_name]`,
        item.product_name
      );
      appendIfValue(
        `product_profiles[${index}][product_desc]`,
        item.product_desc
      );
    });

    basicData.domain_types.forEach((item, index) => {
      appendIfValue(`domain_types[${index}][domain_name]`, item.domain_name);
      appendIfValue(`domain_types[${index}][id]`, item.id);
    });

    if (basicData.financial_records && Array.isArray(basicData.financial_records)) {
      basicData.financial_records.forEach((item, index) => {
        appendIfValue(`financial_records[${index}][financial_year]`, item.financial_year);
        appendIfValue(`financial_records[${index}][fy_turnover]`, item.fy_turnover);
        appendIfValue(`financial_records[${index}][capital_investment]`, item.capital_investment);
        appendIfValue(`financial_records[${index}][total_capital_investment]`, item.total_capital_investment);
        appendIfValue(`financial_records[${index}][remarks]`, item.remarks);
        appendIfValue(`financial_records[${index}][male_onboarded]`, item.male_onboarded);
        appendIfValue(`financial_records[${index}][female_onboarded]`, item.female_onboarded);
        appendIfValue(`financial_records[${index}][genderqueer_onboarded]`, item.genderqueer_onboarded);
        appendIfValue(`financial_records[${index}][total_onboarded]`, item.total_onboarded);
        appendIfValue(`financial_records[${index}][sc_st_onboarded]`, item.sc_st_onboarded);
        appendIfValue(`financial_records[${index}][pwd_onboarded]`, item.pwd_onboarded);
        appendIfValue(`financial_records[${index}][dir_employ_male]`, item.dir_employ_male);
        appendIfValue(`financial_records[${index}][dir_employ_female]`, item.dir_employ_female);
        appendIfValue(`financial_records[${index}][dir_employ_others]`, item.dir_employ_others);
        appendIfValue(`financial_records[${index}][dir_employ_sc_st]`, item.dir_employ_sc_st);
        appendIfValue(`financial_records[${index}][dir_employ_pwd]`, item.dir_employ_pwd);
        appendIfValue(`financial_records[${index}][direct_emp]`, item.direct_emp);
      });
    }

    // setIsActive(true);
    update_company_registration(basicData?.id, form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        let errMsg = "An error occurred";
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            errMsg = error.response.data.message;
          }
          if (error.response.data.error) {
            const errors = error.response.data.error;
            if (typeof errors === "object") {
              const firstKey = Object.keys(errors)[0];
              if (firstKey && Array.isArray(errors[firstKey]) && errors[firstKey][0]) {
                errMsg = errors[firstKey][0];
              }
            } else if (typeof errors === "string") {
              errMsg = errors;
            }
          } else if (error.response.data.errors) {
            const errors = error.response.data.errors;
            if (typeof errors === "object") {
              const firstKey = Object.keys(errors)[0];
              if (firstKey && Array.isArray(errors[firstKey]) && errors[firstKey][0]) {
                errMsg = errors[firstKey][0];
              }
            }
          }
        }
        setSnackMessage(errMsg);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
    // user_dash_list()
  };

  let userData = jwtDecode(props.state.payload);
  const getDetails = (domData) => {
    let otherDom = [];
    user_company_details(userData?.user?.id).then((res) => {
      // let mobile_number= res?.phone_no,
      let Data = res?.data;
      otherDom = Data?.domain_types?.filter(
        (ar1) => !domData.some((ar2) => ar1?.domain_name === ar2?.domain_name)
      );

      domData?.forEach((item) => {
        item["checked"] = Data?.domain_types?.some(
          (dom) => item?.domain_name === dom?.domain_name
        );
      });
      setDomain(domData);
      let d = {
        ...Data,
        any_other_flag:
          Data.any_other_flag && Data.any_other_flag !== "0" ? true : false,
        any_other_domain:
          Data.any_other_domain && Data.any_other_flag !== "0"
            ? Data.any_other_domain
            : "",
        country_code:
          Data.country_code === "null" || Data.country_code === "undefined"
            ? ""
            : Data.country_code,
      };
      const standardCertifications = ["ISO", "MSME", "KS9100", "ISO9000/2050", "Z_Certfication"];
      let certValue = "";
      let otherCertValue = "";
      if (Data?.certification && Data.certification !== "null" && Data.certification !== "undefined") {
        const trimmedCert = String(Data.certification).trim();
        if (trimmedCert !== "") {
          if (standardCertifications.includes(trimmedCert)) {
            certValue = trimmedCert;
          } else {
            certValue = "Other";
            otherCertValue = trimmedCert;
          }
        }
      }
      setBasicData({
        ...d,
        mobile_number: Data.phone_no,
        file_name: Data?.upload_proposal,
        registration_certificate_name: Data?.registration_certificate,
        logo_name: Data?.logo,
        certification: certValue,
        otherCertification: otherCertValue
      });
      setIsActive(false);
    });
  };
  useEffect(() => {
    getDomainTypes();
  }, []);
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      setActiveStep(0);
      setBasicData({});

      setDomain([]);
      // props.logout();
      props.history.push("/dashboard");
    }
  };
  console.log(basicData);
  return (
    <div className="page-bg" ref={myRef}>
      <div>
        <Loader open={isActive} />
        <div className="dash-banner ">
          <div className="tit-txt">Update - Affiliate an Existing Aerospace Unit in Kerala with KSPACE</div>
        </div>
      </div>
      <div className="formbg form-bg">
        <div className="container ">
          <div className="mb-3 d-flex justify-content-start">
            <button
              type="button"
              className="btn btn-light border"
              style={{
                borderRadius: "6px",
                padding: "8px 20px",
                fontWeight: "bold",
                fontSize: "14px",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px"
              }}
              onClick={() => props.history.push("/dashboard")}
            >
              <i className="fa fa-arrow-left"></i> Back to Dashboard
            </button>
          </div>
          <div className="">
            <div className="fomy form-inner-section">
              {activeStep === 0 && !isActive && (
                <BasicDetails
                  {...props}
                  data={basicData}
                  update={true}
                  action={action}
                  formData={basicData}
                  setDomain={setDomain}
                  domainData={domainData}
                />
              )}

              {activeStep === 1 && (
                <View
                  {...props}
                  basicData={basicData}
                  action={action}
                  update={true}
                />
              )}
            </div>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
